import { render, staticRenderFns } from "./author-apply.vue?vue&type=template&id=738fb522&scoped=true"
import script from "./author-apply.vue?vue&type=script&lang=js"
export * from "./author-apply.vue?vue&type=script&lang=js"
import style0 from "./author-apply.vue?vue&type=style&index=0&id=738fb522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738fb522",
  null
  
)

export default component.exports